import { render, staticRenderFns } from "./ImageSideDialog.vue?vue&type=template&id=9d55c22e&"
import script from "./ImageSideDialog.vue?vue&type=script&lang=ts&"
export * from "./ImageSideDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports